import { Injectable } from '@angular/core';
import { ApiServiceBase } from '@api/abstracts';
import { SubscriptionPlan, SubscriptionPlanListResponseSchema } from '@api/models/dashboard';
import { map, Observable } from 'rxjs';

/**
 * Subscription plans catalog (physical store).
 * Admin API: GET /subscriptions/plans (base already includes /api/v1).
 * V1 returns a single plan; callers read the cheapest price for display.
 *
 * Local dev responses are served by the mock registry (mock.ts), matched on this fixed path.
 */
@Injectable({
  providedIn: 'root',
})
export class SubscriptionPlansData extends ApiServiceBase<SubscriptionPlan> {
  constructor() {
    super('subscriptions/plans', 'evoqAdmin');
  }

  fetchSubscriptionPlans(): Observable<SubscriptionPlan[]> {
    return this.list().pipe(
      map((response) => {
        const result = SubscriptionPlanListResponseSchema.safeParse(response);
        if (!result.success) {
          throw new Error('Invalid subscription plans response');
        }
        return result.data;
      })
    );
  }
}
